import { Vue, Component, Prop } from "vue-property-decorator";
import { } from '@types/googlemaps';

interface IMapMarker {
    lng: number;
    lat: number;
    icon: string;
}

@Component
export default class GoogleMap extends Vue {
    _data: any;
    @Prop() id: string;

    @Prop() address: string;
    @Prop() latitude: string;
    @Prop() longitude: string;

    @Prop() minZoom: string;
    @Prop() maxZoom: string;
    @Prop() zoom: string;
    @Prop() markerJson: string;

    @Prop() shouldShowControls: boolean;


    createMap(location?: google.maps.LatLng) {
        const element = this.$el;
        
        var zoom = parseFloat(this.zoom) || 12;
        var minZoom = parseFloat(this.minZoom) || zoom;
        var maxZoom = parseFloat(this.maxZoom) || zoom;

        var latLng = location || {
            lat: parseFloat(this.latitude),
            lng: parseFloat(this.longitude)
        };
        let enableControls = !!this.shouldShowControls;

        var options = {
            gestureHandling: 'cooperative',
            zoom: zoom,
            minZoom: minZoom,
            maxZoom: maxZoom,
            center: latLng,
            styles: this._data.styles,
            
            disableDefaultUI: !enableControls,

            keyboardShortcuts: enableControls,
            panControl: enableControls,
            draggable: enableControls,
            zoomControl: enableControls,

            mapTypeControl: false,
            scaleControl: enableControls,
            streetViewControl: false,
            overviewMapControl: enableControls,
            rotateControl: enableControls,

            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP]
            },
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            
        } as google.maps.MapOptions;

        var map = new google.maps.Map(element, options);

        if (this.markerJson) {
            let markers = JSON.parse(this.markerJson) as Array<IMapMarker>;

            for (let i = 0; i < markers.length; i++) {
                var marker = markers[i];

                let latLng = {
                    lat: marker.lat,
                    lng: marker.lng
                };

                new google.maps.Marker({
                    position: latLng,
                    map: map,
                    icon: marker.icon
                });
            }
        }

        this._data.map = map;
    }

    fetchAddress(address: string, callback: Function) {
        new google.maps.Geocoder().geocode({ address: address },
            (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
                if (status !== google.maps.GeocoderStatus.OK) {
                    return null;
                }

                if (callback) {
                    callback(results);
                }

                return results;
            });
    }

    mounted() {
        var lat = parseFloat(this.latitude);
        var lng = parseFloat(this.longitude);

        if (!(lat || lng) && this.address) {
            this.fetchAddress(this.address,
                (locations: google.maps.GeocoderResult[]) => {
                    this._data.location = locations[0].geometry.location;
                    this.createMap(this._data.location);
                }
            );
        }
        else if (lat || lng) {

            this._data.location = {
                lat: lat,
                lng: lng
            };
            this.createMap(this._data.location);
        }

        window.addEventListener('resize', this.handleResize);
    }

    beforeDestroy () {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this._data.map.setCenter(this._data.location);
    }

    data() {
        return {
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#9d9d9d"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#bdbdbd"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#9d9d9d"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dadada"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                }
            ] as google.maps.MapTypeStyle[]
        } 
    }
}


// WEBPACK FOOTER //
// ./www/js/Components/GoogleMap/GoogleMap.ts